import { PaymentMethodName } from '../../domain/Payment';

export const ExpressPaymentMethods: Array<PaymentMethodName> = ['PAYPAL_EXPRESS'];
